//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../Facet/Facet.SelectFacetedBody.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AsOriginalOption",1,0],[0,"ContinuityTypeOption",1,0],[0,"DistanceTolerance",1,0],[1,"EndFacetBody",0,"Facet.SelectFacetedBody",0],[0,"HideOriginal",1,0],[0,"MeshTopologyOption",1,0],[0,"SCMeshOption",1,0],[0,"ShowTransformVectors",1,0],[0,"SmoothingOption",1,0],[1,"StartFacetBody",0,"Facet.SelectFacetedBody",0],[0,"StepCount",1,0],[1,"TransformCurves",0,"Section",0],[1,"TransformFaces",0,"ScCollector",0],[0,"TransformFactor",1,0]],[[["numFeatures","transformedFeatures"],"GetFeatures",{},0,0]],[]];
SPLM.Features.MeshTransformerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MeshTransformerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MeshTransformerBuilder.MeshTopologyType = Object.freeze({
    "Aligned" : "Aligned", "Unaligned" : "Unaligned", "EndOnly" : "EndOnly"});

SPLM.Features.MeshTransformerBuilder.ContinuityType = Object.freeze({
    "C2" : "C2", "C4" : "C4"});

SPLM.Features.MeshTransformerBuilder.SmoothingType = Object.freeze({
    "VeryLow" : "VeryLow", "Low" : "Low", "Normal" : "Normal", "High" : "High", "VeryHigh" : "VeryHigh", "SuperLow" : "SuperLow"});

SPLM.Features.MeshTransformerBuilder.StepCountValue = Object.freeze({
    "Number8" : "Number8", "Number16" : "Number16", "Number32" : "Number32", "Number64" : "Number64", "Number128" : "Number128", "Number256" : "Number256", "Number512" : "Number512"});

export default SPLM;